import { render, staticRenderFns } from "./MInput.vue?vue&type=template&id=e2079e00&scoped=true"
import script from "./MInput.vue?vue&type=script&lang=js"
export * from "./MInput.vue?vue&type=script&lang=js"
import style0 from "./MInput.vue?vue&type=style&index=0&id=e2079e00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2079e00",
  null
  
)

export default component.exports